export enum FeatureFlagEnum {
  ERP_INTEGRATION = "erpIntegration",
  MASS_CUSTOMER_CREATION = "massCustomerCreation",
  SHOW_METERS_IN_MULTIPLE_QUOTE = "showMetersInMultipleQuote",
  HOUSING_QUOTE_DESCRIPTION = "housingQuoteDescription",
  PRINT_PAYMENT_PLAN = "printPaymentPlan",
}

export interface FeatureFlag {
  key: FeatureFlagEnum;
  enabled: boolean;
}
